import { Navigate, Outlet, useLocation } from 'react-router-dom'

import Loading from '../../loading/Loading'

import { useConfirm } from '../../../contexts/ConfirmContext'
import { useProfileContext } from '../../../contexts/ProfileContext'

const ProfileCompletionGuard = () => {
  const { pathname } = useLocation()
  const { confirmData } = useConfirm()

  const { profile, loading, error } = useProfileContext()

  if (!profile && (loading || !error)) {
    return <Loading />
  }

  if (
    profile &&
    profile.termsConsent !== true &&
    pathname !== '/account/setup' &&
    pathname !== '/account/terms-and-conditions' &&
    !(pathname === '/confirm' && confirmData?.allowIncompleteProfile === true)
  ) {
    return <Navigate to="/account/setup" replace />
  }

  // Until the email is confirmed only the booking page (with the confirmation notice), the account pages and the help
  // center are open.
  if (
    profile?.emailConfirmed === false &&
    pathname !== '/booking' &&
    pathname !== '/help' &&
    !pathname.startsWith('/account')
  ) {
    return <Navigate to="/booking" replace />
  }

  return <Outlet />
}

export default ProfileCompletionGuard
